var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 单独的路由 "),_c('div',[_c('Button',{staticStyle:{"margin-left":"100px"},attrs:{"type":"primary"},on:{"click":_vm.reback}},[_vm._v("返回")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }